import { useState } from "react";
import axios from "axios";
import { useTranslation } from "next-i18next";
import {
    EnvelopeIcon,
    MapPinIcon,
    PhoneArrowUpRightIcon,
} from "@heroicons/react/24/solid";
import Image from "next/image";
import useGeneralStore from "@/store/General/useGeneralStore";

const ContactComponent = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === "ar";
    const { Socials } = useGeneralStore((state) => state);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
    });
    const [formStatus, setFormStatus] = useState<any>({});
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        setFormStatus({ status: "", message: "" });
        try {
            await axios.post(
                `${process.env.NEXT_PUBLIC_API_URL}/General/PartnerContactUs`,
                formData
            );
            setFormStatus({
                status: "success",
                message: t("home.contactForm.successMessage"),
            });
            setFormData({
                name: "",
                email: "",
                phone: "",
                subject: "",
            });
        } catch (error) {
            setFormStatus({
                status: "error",
                message: t("home.contactForm.errorMessage"),
            });
        }
    };

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <div className="w-full bg-[#F4F7FA] text-primary flex justify-center py-[5rem] ">
            <div className="w-[80%] grid grid-cols-1 md:grid-cols-3">
                <div className="col-span-2">
                    <div className="text-[2rem] w-[70%] font-bold">
                        {t("home.contactForm.title")}
                    </div>
                    <div>
                        <div className="w-[50%] mt-[2rem]">
                            {t("home.contactForm.subtitle")}
                        </div>
                        <div
                            className="font-bold text-right mt-2"
                            style={{ direction: "ltr" }}
                        >
                            {Socials?.partnerWhatsApp}
                        </div>
                    </div>
                    <div className="text-primary mt-[2rem] flex w-full gap-[2rem] ">
                        <div className="flex text-left text-[1] gap-[0.5rem] items-center justify-center">
                            <PhoneArrowUpRightIcon className="w-[1.5rem] text-secondary" />
                            {t("home.contactForm.phone")}
                        </div>
                        <div className="flex text-left text-[1] gap-[0.5rem] items-center justify-center">
                            <EnvelopeIcon className="w-[1.5rem] text-secondary" />
                            {t("home.contactForm.email")}
                        </div>
                        <div
                            className={`flex ${
                                isAr ? "text-right" : "text-left"
                            } text-[1] gap-[0.5rem] items-center justify-start `}
                        >
                            <MapPinIcon className="w-[1.5rem] text-secondary " />
                            <div className="w-[80%] text-[0.7rem] md:text-[1rem]">
                                {t("home.contactForm.address")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full md:w-[28rem] h-[40rem] text-[0.7rem] mt-[4rem] md:mt-0">
                    <form
                        data-aos="fade-right"
                        className="bg-[white] h-full w-full rounded-[0.5rem] grid grid-rows-5 p-[1.5rem] gap-[1rem] shadow-xl"
                        onSubmit={handleFormSubmit}
                    >
                        <div className="mt-[1rem]">
                            <label
                                className="block text-[black] text-[1rem] mb-[0.5rem]"
                                htmlFor="username"
                            >
                                {t("home.contactForm.name")}
                            </label>
                            <input
                                required
                                className="appearance-none border-[0.1rem] border-[#E7E9ED] text-[#5c616c] rounded w-full pt-[1rem] pb-[1.3rem] px-[0.9rem] leading-tight focus:outline-none focus:shadow-outline"
                                id="username"
                                type="text"
                                name="name"
                                placeholder={t(
                                    "home.contactForm.namePlaceholder"
                                )}
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="mt-[1rem]">
                            <label
                                className="block text-[black] text-[1rem] mb-[0.5rem]"
                                htmlFor="email"
                            >
                                {t("home.contactForm.email")}
                            </label>
                            <input
                                required
                                className="appearance-none border-[0.1rem] border-[#E7E9ED] text-[#5c616c] rounded w-full pt-[1rem] pb-[1.3rem] px-[0.9rem] leading-tight focus:outline-none focus:shadow-outline"
                                id="email"
                                type="text"
                                name="email"
                                placeholder={t(
                                    "home.contactForm.emailPlaceholder"
                                )}
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="mt-[1rem]">
                            <label
                                className="block text-[black] text-[1rem] mb-[0.5rem]"
                                htmlFor="phone"
                            >
                                {t("home.contactForm.phone")}
                            </label>
                            <input
                                required
                                className="appearance-none border-[0.1rem] border-[#E7E9ED] text-[#5c616c] rounded w-full pt-[1rem] pb-[1.3rem] px-[0.9rem] leading-tight focus:outline-none focus:shadow-outline"
                                id="phone"
                                type="text"
                                name="phone"
                                placeholder={t(
                                    "home.contactForm.phonePlaceholder"
                                )}
                                value={formData.phone}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="mt-[1rem]">
                            <label
                                className="block text-[black] text-[1rem] mb-[0.5rem]"
                                htmlFor="subject"
                            >
                                {t("home.contactForm.subject")}
                            </label>
                            <input
                                required
                                className="appearance-none border-[0.1rem] border-[#E7E9ED] text-[#5c616c] rounded w-full pt-[1rem] pb-[1.3rem] px-[0.9rem] leading-tight focus:outline-none focus:shadow-outline"
                                id="subject"
                                type="text"
                                name="subject"
                                placeholder={t(
                                    "home.contactForm.subjectPlaceholder"
                                )}
                                value={formData.subject}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div>
                            {formStatus.status && (
                                <div
                                    className={`font-bold text-[1rem] mb-[1.0rem] ${
                                        formStatus.status === "success"
                                            ? "text-[green]"
                                            : "text-[red]"
                                    }`}
                                >
                                    {formStatus.message}
                                </div>
                            )}
                            <button className="bg-primary text-[white] w-full h-[5rem] rounded-[0.7rem]">
                                {t("home.contactForm.submit")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Image
                src={"/icons/waveIco-2.svg"}
                width={1000}
                height={1000}
                alt="explain"
                className="w-full -bottom-[0.8rem] absolute left-0"
            />
        </div>
    );
};

export default ContactComponent;
